import { useState, useEffect } from "react"
import StorageService from "@/services/Storage"
import { isMoreOrEqualThanDaysAgo } from "@/utils/time"
import { useGlobalStateStore } from "@/store/GlobalState"
import { externalLinks } from "@/utils/link"

type ReferAndEarnOptionsData = {
	hidden: boolean
	createdAt: string
}

export const QUANTITY_OF_DAYS_TO_HIDE_REFER_AND_EARN_ALERT = 7

export function useReferAndEarn () {
	const [isReferAndEarnAlertVisible, setIsReferAndEarnAlertVisible] = useState<boolean>(true)
	const globalStateStore = useGlobalStateStore()

	const getReferAndEarnStorageKey = (): string => {
		return StorageService.mountKey(
			StorageService.reservedKeys.INBOX_REFER_AND_EARN_PREFERENCE,
			String(globalStateStore.instance.instance_id)
		)
	}

	const getPreferenceFromStorage = (): ReferAndEarnOptionsData | null => {
		return StorageService.get<ReferAndEarnOptionsData>(getReferAndEarnStorageKey())
	}

	const setPreferenceInStorage = (options: ReferAndEarnOptionsData): void => {
		StorageService.set<ReferAndEarnOptionsData>(getReferAndEarnStorageKey(), options)
	}

	const removePreferenceFromStorage = (): void => {
		StorageService.delete(getReferAndEarnStorageKey())
	}

	const canReferAndEarn = (): boolean => {
		const storedPreference = getPreferenceFromStorage()

		if (storedPreference) {
			if (isMoreOrEqualThanDaysAgo(
				new Date(storedPreference.createdAt),
				QUANTITY_OF_DAYS_TO_HIDE_REFER_AND_EARN_ALERT
			)) {
				removePreferenceFromStorage()
				return true
			}
			return !storedPreference.hidden
		}

		return true
	}

	useEffect(() => {
		setIsReferAndEarnAlertVisible(canReferAndEarn())
	}, [])

	const hideAlert = () => {
		const options: ReferAndEarnOptionsData = {
			hidden: true,
			createdAt: new Date().toString()
		}

		setPreferenceInStorage(options)
		setIsReferAndEarnAlertVisible(false)
	}

	const openReferAndEarnPage = () => {
		window.open(externalLinks.referAndEarn, "_blank")
	}

	return {
		isReferAndEarnAlertVisible,
		hideAlert,
		daysQuantityToHideAlert: QUANTITY_OF_DAYS_TO_HIDE_REFER_AND_EARN_ALERT,
		openReferAndEarnPage
	}
}
